// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date___dGAj","head":"ProcedureTableInfo_head__2t4yL"};